import { z } from "zod";
import { dashboardCard, dashboardPlotBlockV2, fermentationDashboardLayoutV2, } from "./fermentation-dashboard-v2";
export const cardBlock = dashboardCard;
export const plotBlock = dashboardPlotBlockV2;
export const fermentationDashboardLayout = fermentationDashboardLayoutV2;
export const fermentationDashboardBlock = z.discriminatedUnion("type", [
    cardBlock,
    plotBlock,
]);
export function parseFermentationDashboard(raw) {
    const parsed = fermentationDashboardLayout.safeParse(raw);
    return parsed.success ? parsed.data : null;
}
export function emptyFermentationDashboard() {
    return {
        kind: "fermentation",
        version: 2,
        groups: [],
        blocks: [],
        reviewedBindings: null,
    };
}
export function nextBlockId(layout, type) {
    const existing = new Set(layout.blocks.map((block) => block.id));
    let suffix = 1;
    while (existing.has(`${type}-${suffix}`))
        suffix++;
    return `${type}-${suffix}`;
}
//# sourceMappingURL=fermentation-dashboard.js.map